var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignatureBased({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8371 13.1224L9.38318 14.4963L8.75143 11.7552L12.8532 2.49819C13.0345 2.08901 13.3709 1.76861 13.7885 1.60747C13.9952 1.52769 14.2157 1.48941 14.4372 1.49481C14.6588 1.50022 14.8771 1.54921 15.0797 1.63899C15.2823 1.72876 15.4652 1.85756 15.618 2.01804C15.7709 2.17851 15.8906 2.36752 15.9704 2.57427C16.0502 2.78101 16.0885 3.00145 16.083 3.22299C16.0776 3.44453 16.0287 3.66283 15.9389 3.86544L11.8371 13.1224Z",
    stroke: "#4152B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3975 3.52734L15.4831 4.8946",
    stroke: "#4152B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 15.625C10.125 15.9234 10.0065 16.2095 9.79549 16.4205C9.58452 16.6315 9.29837 16.75 9 16.75H1.125",
    stroke: "#4152B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureBased);
export default __webpack_public_path__ + "static/media/signature-based.2a96679f.svg";
export { ForwardRef as ReactComponent };